import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Client } from 'persona';


@Component({
    selector: 'app-id-verification',
    templateUrl: './idverification.component.html',
    styleUrls: ['./idverification.component.scss'],
    standalone: false
})
export class IDVerificationComponent {
  @Input() personaSettings: { TemplateId: string; EnvironmentId:string};
  @Input() facilityId: number;
  @Input() tenantId: number;

  @Output() verificationCompleted = new EventEmitter<{
    success: boolean;
    inquiryId?: string;
    status?: string;
  }>();

  constructor() { }

  ngOnInit(): void { }

  startVerification() {
    const client = new Client({
      templateId: this.personaSettings.TemplateId,
      environmentId: this.personaSettings.EnvironmentId, 

      onReady: () => client.open(),
      onComplete: async ({ inquiryId, status }) => {
          this.verificationCompleted.emit({ success: true, inquiryId, status});
          client.destroy();  
      },

      onCancel: () => {
        this.verificationCompleted.emit({ success: false });
        client.destroy();
      },
      onError: error => {
        this.verificationCompleted.emit({ success: false });
        client.destroy();
      }
    });
  }

  verifyInStore() {
    this.verificationCompleted.emit({ success: true ,status: 'in-store'});
  }
}
